import { useRef, useState } from 'react';

import {
  ArrowDown01Icon,
  Folder02Icon,
  Settings02Icon,
  Tick01Icon,
} from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';
import { useClickOutside } from 'hooks/click-outside';
import { useTranslation } from 'react-i18next';

import { SavedViewDefaultToggle } from './SavedViewDefaultToggle';
import styles from './SavedViewsDropdown.module.scss';

const MANAGE_LABEL_KEY = {
  checks: 'reporting.manageChecksViews',
  candidates: 'reporting.manageCandidatesViews',
  referees: 'reporting.manageRefereesViews',
};

export const SavedViewsDropdown = ({
  savedViews,
  activeViewId,
  onSelectView,
  onSetDefault,
  onManage,
  tab,
}) => {
  const { t } = useTranslation();
  const manageLabelKey = MANAGE_LABEL_KEY[tab] ?? 'reporting.manageSavedViews';
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useClickOutside(ref, () => setOpen(false));

  const handleSelect = view => {
    onSelectView(view.id, view.savedQueryParams ?? {});
    setOpen(false);
  };

  const activeLabel = savedViews.find(v => Number(v.id) === Number(activeViewId))?.name ?? null;

  return (
    <div ref={ref} className={styles.savedViewsWrapper}>
      <button
        className={cn(styles.savedViewsBtn, { [styles.savedViewsBtnOpen]: open })}
        type="button"
        onClick={() => setOpen(o => !o)}>
        <HugeiconsIcon icon={Folder02Icon} size={18} strokeWidth={1.5} />
        <span className={styles.savedViewsBtnName}>{activeLabel ?? t('reporting.savedViews')}</span>
        <HugeiconsIcon icon={ArrowDown01Icon} size={15} strokeWidth={1.5} />
      </button>
      {open && (
        <div className={styles.savedViewsDropdown}>
          <p className={styles.savedViewsHeader}>{t('reporting.savedViews')}</p>
          {savedViews.map(view => (
            <div
              key={view.id}
              className={cn(styles.savedViewsItem, {
                [styles.savedViewsItemActive]: Number(view.id) === Number(activeViewId),
              })}>
              <button
                type="button"
                className={styles.savedViewsItemSelect}
                onClick={() => handleSelect(view)}>
                <div className={styles.savedViewsItemIcon}>
                  {Number(view.id) === Number(activeViewId) && (
                    <HugeiconsIcon icon={Tick01Icon} size={16} strokeWidth={2} />
                  )}
                </div>
                <div className={styles.savedViewsItemContent}>
                  <span className={styles.savedViewsItemName} title={view.name}>
                    {view.name}
                  </span>
                </div>
              </button>
              <div className={styles.savedViewsItemActions}>
                <SavedViewDefaultToggle
                  viewId={view.id}
                  isDefault={view.isDefault}
                  onSetDefault={onSetDefault}
                />
              </div>
            </div>
          ))}
          <div className={styles.savedViewsDivider} />
          <button
            type="button"
            className={styles.savedViewsManageBtn}
            onClick={() => {
              setOpen(false);
              onManage();
            }}>
            <HugeiconsIcon icon={Settings02Icon} size={16} strokeWidth={1.5} />
            <span>{t(manageLabelKey)}</span>
          </button>
        </div>
      )}
    </div>
  );
};
